import * as XLSX from 'xlsx';
import { getCustomFields } from './customFieldsManager';
import { getDocuments } from './documentManager';

/**
 * Export property data to Excel file
 * @param {Array} properties - Array of property objects
 * @param {string} filename - Name of the exported file
 */
export const exportPropertiesToExcel = (properties, filename = 'properties_export') => {
  if (!properties || properties?.length === 0) {
    console.warn('No properties to export');
    return;
  }

  const customFields = getCustomFields();

  // Transform property data for Excel
  const excelData = properties?.map((property) => {
    const baseData = {
      'Property ID': property?.id || '',
      'Title': property?.title || '',
      'Type': property?.type || '',
      'Status': property?.status || '',
      'Price': property?.price || '',
      'Area (sqm)': property?.area || '',
      'Bedrooms': property?.bedrooms || '',
      'Bathrooms': property?.bathrooms || '',
      'Location': property?.location || '',
      'Address': property?.address || '',
      'Owner': property?.owner || '',
      'Agent': property?.agent || '',
      'Listed Date': property?.listedDate || '',
      'Description': property?.description || '',
    };

    // Add document count
    const propertyDocs = getDocuments('property', property?.id || property?.propertyId);
    baseData['Documents Count'] = propertyDocs?.length || 0;
    baseData['Document Names'] = propertyDocs?.map(doc => doc?.name)?.join(', ') || 'لا يوجد';

    // Add custom fields to export
    customFields?.forEach(field => {
      const value = property?.customFields?.[field?.id];
      if (value !== undefined && value !== null) {
        baseData[field?.label] = field?.type === 'checkbox' ? (value ? 'نعم' : 'لا') : value;
      }
    });

    return baseData;
  });

  // Create worksheet
  const worksheet = XLSX?.utils?.json_to_sheet(excelData);

  // Set column widths
  const columnWidths = [
    { wch: 12 }, // Property ID
    { wch: 30 }, // Title
    { wch: 15 }, // Type
    { wch: 12 }, // Status
    { wch: 15 }, // Price
    { wch: 12 }, // Area
    { wch: 10 }, // Bedrooms
    { wch: 10 }, // Bathrooms
    { wch: 20 }, // Location
    { wch: 35 }, // Address
    { wch: 20 }, // Owner
    { wch: 20 }, // Agent
    { wch: 15 }, // Listed Date
    { wch: 50 }, // Description
  ];

  // Add column widths for custom fields
  customFields?.forEach(() => {
    columnWidths?.push({ wch: 20 });
  });

  worksheet['!cols'] = columnWidths;

  // Create workbook
  const workbook = XLSX?.utils?.book_new();
  XLSX?.utils?.book_append_sheet(workbook, worksheet, 'Properties');

  // Generate Excel file
  const timestamp = new Date()?.toISOString()?.split('T')?.[0];
  XLSX?.writeFile(workbook, `${filename}_${timestamp}.xlsx`);
};

/**
 * Export filtered property data to Excel
 * @param {Array} properties - Array of property objects
 * @param {Object} filters - Applied filters
 * @param {string} filename - Name of the exported file
 */
export const exportFilteredPropertiesToExcel = (properties, filters, filename = 'filtered_properties') => {
  let filteredProperties = [...properties];

  // Apply filters
  if (filters?.status && filters?.status !== 'all') {
    filteredProperties = filteredProperties?.filter(p => p?.status === filters?.status);
  }
  if (filters?.type && filters?.type !== 'all') {
    filteredProperties = filteredProperties?.filter(p => p?.type === filters?.type);
  }
  if (filters?.location) {
    filteredProperties = filteredProperties?.filter(p => 
      p?.location?.toLowerCase()?.includes(filters?.location?.toLowerCase())
    );
  }

  exportPropertiesToExcel(filteredProperties, filename);
};

export default {
  exportPropertiesToExcel,
  exportFilteredPropertiesToExcel,
};